import { useEffect } from 'react';
import Menu from '../menu/Menu';
import { SortInstance, SortOrder } from './hooks';
import Button from '../button/Button';
import RadioGroup from '../radio-group/RadioGroup';
import Select from '../select/Select';

export type SortBodyProps = {
    sortInstance: SortInstance;
    options: string[] | { id: string; label: string }[];
};

function SortMenu({ sortInstance, options }: SortBodyProps): JSX.Element {
    useEffect(() => {
        return (): void => {
            sortInstance.reset();
        };
    }, []);

    return (
        <>
            <div className="p-2">
                <section className="border-b pb-2">
                    <RadioGroup
                        groupName="Sort Direction"
                        // legend="Sort Direction"
                        options={[
                            { label: 'Ascending', value: 'asc' },
                            { label: 'Descending', value: 'desc' },
                        ]}
                        onChange={(e): void => sortInstance.updateSortOrder(e.target.value as SortOrder)}
                        orientation="horizontal"
                        value={sortInstance.sortOrder}
                    />
                </section>
                <section className="mt-4">
                    <Select
                        isClearable={false}
                        showMenuAsRelative
                        onChange={(options): void => sortInstance.updateSortOption(options[0].value.toString())}
                        isMulti={false}
                        placeholder="Sort by..."
                        options={options.map((o) => ({
                            value: typeof o === 'string' ? o : o.id,
                            label: typeof o === 'string' ? o : o.label,
                            isSelected: typeof o === 'string' ? sortInstance.sortOption === o : sortInstance.sortOption === o.id,
                        }))}
                    />
                </section>
            </div>
            <div className="flex justify-between p-2 dark:bg-white/[0.04] bg-gray-100">
                {/* <Menu.Button> */}
                <Button
                    type="secondary"
                    label="Clear"
                    size="xs"
                    onClick={(): void => {
                        sortInstance.clear();
                    }}
                />
                {/* </Menu.Button> */}
                <Menu.Button>
                    <Button
                        type="primary"
                        label="Apply"
                        size="xs"
                        onClick={(): void => {
                            sortInstance.apply();
                        }}
                    />
                </Menu.Button>
            </div>
        </>
    );
}
export default SortMenu;
